/**
 * Formats a number as currency string.
 * @param value - The number to format.
 * @param currency - The currency code (default: USD).
 * @returns Formatted currency string.
 */
export function formatCurrency(value: number, currency = "IDR"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(value);
}

/**
 * Formats a number with thousand separators.
 * @param value - The number to format.
 * @returns Formatted number string.
 */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}
